import type { ConversationNodeQueue } from 'lib-shared-types-api';

type Props = {
  node: ConversationNodeQueue;
};

export function RoutedThroughQueue({ node }: Props): JSX.Element {
  return (
    <>
      Queue · Added to <strong>{node.label}</strong>
    </>
  );
}
